import { IonButton, IonCol, IonRow } from "@ionic/react";
import React, { FC, ReactNode } from "react";
import AIModal from "../../elements/AIModal";

interface IProps {
  opened: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  confirmColor?: string; // Ionic color; "danger" for destructive actions
  onConfirm: () => void;
  onCancel: () => void;
}

// "Are you sure?" dialog built on AIModal, in the style of ConfirmDeleteBtnModal
const ConfirmActionModal: FC<IProps> = ({
  opened,
  title,
  message,
  confirmLabel = "Confirm",
  confirmColor = "danger",
  onConfirm,
  onCancel,
}) => (
  <AIModal
    opened={opened}
    setOpened={(open: boolean) => {
      if (!open) onCancel();
    }}
    title={title}
    style={{ "--height": "240px", "--max-height": "90%" }}
  >
    <IonRow className="ion-justify-content-center">
      <IonCol className="delete-warning">{message}</IonCol>
    </IonRow>
    <IonRow className="ion-justify-content-center">
      <IonButton color={confirmColor} onClick={onConfirm}>
        {confirmLabel}
      </IonButton>
      <IonButton color="medium" onClick={onCancel}>
        Cancel
      </IonButton>
    </IonRow>
  </AIModal>
);

export default ConfirmActionModal;
